import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Hash } from "lucide-react";

export default function NumberingCard() {
  const [n, setN] = useState(null);
  const [val, setVal] = useState("");
  const load = () => api.get("/numbering").then((r) => { setN(r.data); setVal(String(r.data.next_number)); }).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async () => {
    const num = parseInt(val, 10);
    if (!num || num < 1) { toast.error("Enter a whole number of 1 or more"); return; }
    try {
      const { data } = await api.put("/numbering", { next_number: num });
      setN(data); setVal(String(data.next_number));
      toast.success("Proposal numbering updated");
    } catch (e) { toast.error(e.response?.data?.detail || "Could not update numbering"); }
  };
  if (!n) return null;
  const yy = String(n.year).slice(-2);
  return (
    <Card className="p-6 rounded-md max-w-2xl" data-testid="numbering-card">
      <div className="flex items-center gap-2 mb-1"><Hash className="w-4 h-4 text-cass-teal" /><h3 className="font-alt font-semibold text-cass-navy">Proposal numbering</h3></div>
      <p className="text-sm text-cass-slate mb-5">New proposals and renewals share one running number that resets at the start of each calendar year (e.g. <b>PROP-{yy}-001</b> for a new proposal, <b>RNEW-{yy}-001</b> for a renewal). Set the next number below — it then counts up by 1 automatically. Existing references never change.</p>
      <div className="grid sm:grid-cols-2 gap-4 mb-5">
        <div className="p-3 rounded-md bg-cass-bone/60"><div className="text-xs text-cass-slate">Next new proposal</div><div className="text-cass-navy font-semibold text-lg tabular" data-testid="numbering-preview-new">{n.next_new_preview}</div></div>
        <div className="p-3 rounded-md bg-cass-bone/60"><div className="text-xs text-cass-slate">Next renewal</div><div className="text-cass-navy font-semibold text-lg tabular" data-testid="numbering-preview-renewal">{n.next_renewal_preview}</div></div>
      </div>
      <div className="flex items-end gap-3">
        <div>
          <label className="text-xs text-cass-slate">Next number ({n.year})</label>
          <Input type="number" min="1" value={val} onChange={(e) => setVal(e.target.value)} className="w-40" data-testid="numbering-input" />
        </div>
        <Button className="bg-cass-navy text-white" onClick={save} data-testid="numbering-save">Save</Button>
      </div>
    </Card>
  );
}
